/**
 * 消息中心 API
 */
import request from '@/utils/request';

export const getMessageList = (params) =>
  request.get('/message/list', { params });

export const getUnreadCount = (params) =>
  request.get('/message/unread-count', { params });

export const markAsRead = (data) =>
  request.post('/message/mark-read', data);

export const markAllAsRead = (data) =>
  request.post('/message/mark-all-read', data);

export const markBatchRead = (data) =>
  request.post('/message/mark-batch-read', data);

export const deleteMessage = (data) =>
  request.post('/message/delete', data);

export const deleteBatch = (data) =>
  request.post('/message/delete-batch', data);

export const cleanMessages = (data) =>
  request.post('/message/clean', data);

export const getMessageStats = (params) =>
  request.get('/message/stats', { params });

export const getPendingBroadcasts = () =>
  request.get('/message/pending-broadcasts');

export const markBroadcastSeen = (data) =>
  request.post('/message/broadcast/seen', data);
